import { createApp } from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import i18n from '@/plugins/i18n'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import metaInfo from 'vue-meta-info'
import axios from 'axios'
import VueAxios from 'vue-axios'

require('@/plugins/validation')
require('@/plugins/fontawesome')

const app = createApp(App)

app
  .component('font-awesome-icon', FontAwesomeIcon)
  .use(metaInfo)
  .use(VueAxios, axios)
  .use(router)
  .use(store)
  .use(i18n)
  .mount('#app')
